import AlixRepo from "../repositories/AlixRepository";

export default class AlixLogic {
    /**
     * @returns {Promise<any>}
     */
    static getSuggestedAnswers(ratingUuid) {
        return new Promise((resolve, reject) => {
            console.warn('getSuggestedAnswers ' + ratingUuid);

            AlixRepo
                .getSuggestedAnswers(ratingUuid)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    reject(error)
                });
        });
    }

    /**
     * @returns {Promise<any>}
     */
    static postAnswer(ratingUuid, body) {
        return new Promise((resolve, reject) => {
            console.warn('postAnswer ' + ratingUuid);

            AlixRepo
                .postAnswer(ratingUuid, body)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    reject(error)
                });
        });
    }

    /**
     * @returns {Promise<any>}
     */
    static updateAnswer(ratingUuid, answerUuid, body) {
        return new Promise((resolve, reject) => {
            console.warn('updateAnswer ' + ratingUuid);

            AlixRepo
                .updateAnswer(ratingUuid, answerUuid, body)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    reject(error)
                });
        });
    }

    /**
     * @returns {Promise<any>}
     */
    static deleteAnswer(ratingUuid) {
        return new Promise((resolve, reject) => {
            console.warn('deleteAnswer ' + ratingUuid);

            AlixRepo
                .deleteAnswer(ratingUuid)
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    reject(error)
                });
        });
    }

    // Language detection & translation
    static predictLanguages(ratingIds) {
        return new Promise((resolve, reject) => {
            AlixRepo
                .predictLanguages(ratingIds)
                .then((result) => resolve(result))
                .catch((error) => reject(error));
        });
    }

    // Export methods
    static createExport(body) {
        return new Promise((resolve, reject) => {
            AlixRepo
                .createExport(body)
                .then((result) => resolve(result))
                .catch((error) => reject(error));
        });
    }

    static listUserExports() {
        return new Promise((resolve, reject) => {
            AlixRepo
                .listUserExports()
                .then((result) => resolve(result))
                .catch((error) => reject(error));
        });
    }

    static downloadExport(key) {
        return new Promise((resolve, reject) => {
            AlixRepo
                .downloadExport(key, { responseType: 'arraybuffer' })
                .then((result) => resolve(result))
                .catch((error) => reject(error));
        });
    }
}

